import { ThunkDispatch } from '@reduxjs/toolkit';
import axios from 'axios';
import { ERROR_CODE, ErrorModalTypes } from '../../constants/error.constant';
import { RoutesConstant } from '../../constants/routes.constant';
import { setDispatchModal } from './App.slice';
import { debounce } from 'lodash';
import appService from './App.service';
import locationStorageAdapter from '../../services/adapters/locationStorage.adapter';
import { storageConstant } from '../../constants/storage.constant';
import { pushToasts } from '../../hooks/useToast';

const DEBOUNCE_TIME = 350;

export const ssoRefreshThunk = () => {
  return new Promise((resolve, reject) => {
    const refreshToken = locationStorageAdapter.get(
      storageConstant.REFRESH_TOKEN,
    );
    if (!refreshToken) {
      reject('no refresh token');
      return;
    }

    appService
      .ssoRefreshToken(refreshToken as string)
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
};

export const ssoLoginByCodeThunk =
  (code: string) => (dispatch: ThunkDispatch<any, any, any>) => {
    return appService.ssoLoginByCode(code);
  };

export const errorHandlerThunk =
  (err: any) => async (dispatch: ThunkDispatch<any, any, any>) => {
    if (axios.isCancel(err)) return;

    if (err && err.response) {
      const { status, data } = err.response;

      if (status === ERROR_CODE.CUSTOM_CODE) {
        const { error } = data;
        const { code: customStatus, message, data: info } = error;
        let candidates = info;

        try {
          candidates = JSON.parse(info);
        } catch (e) {}

        if (customStatus === ERROR_CODE.UNABLE_TO_DELETE_STATUS_IN_USE) {
          dispatch(pushToasts({options: {type: 'error'}, content: (_: any, t: Function) => t('cannotDeleteUserStatusInUse')}))
          return;
        }

        if (customStatus === ERROR_CODE.UNABLE_TO_DELETE_INTERNSHIP_STATUS_IN_USE) {
          dispatch(pushToasts({options: {type: 'error'}, content: (_: any, t: Function) => t('cannotDeleteInternshipStatusInUse')}))
          return;
        }

        if (customStatus === ERROR_CODE.GOOGLE_UNAVAILABLE) {
          dispatch(pushToasts({options: {type: 'error'}, content: (_: any, t: Function) => t('googleDriveUnavailable')}))
          return;
        }

        if (customStatus === ERROR_CODE.NO_ACCESS) {
          debounce(
            dispatch,
            DEBOUNCE_TIME,
          )(
            setDispatchModal({
              type: ErrorModalTypes.NO_ACCESS,
            }),
          );
          return;
        }

        if (
          customStatus === ERROR_CODE.CANDIDATE_DUPLICATE_SOFT ||
          customStatus === ERROR_CODE.CANDIDATE_DUPLICATE_HARD
        ) {
          debounce(
            dispatch,
            DEBOUNCE_TIME,
          )(
            setDispatchModal({
              type: ErrorModalTypes.CANDIDATE_DUPLICATE,
              data: { candidates, status: customStatus },
            }),
          );
          return;
        }

        console.log(customStatus, message);
        return;
      }

      if (status === ERROR_CODE.NOT_FOUND) {
        return (window.location.href = RoutesConstant.CANDIDATES);
      }

      if (status === ERROR_CODE.FORBIDDEN) {
        debounce(
          dispatch,
          DEBOUNCE_TIME,
        )(
          setDispatchModal({
            type: ErrorModalTypes.FORBIDDEN,
          }),
        );
        return;
      }

      console.log(status, data);
    }
  };
